import { mockData } from '../mock';
import { Quote } from 'lucide-react';

export const Founders = () => {
  return (
    <section id="founders" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">
            Our Leadership
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Meet Our Founders
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Driven by passion and expertise, our founders bring vision and dedication to every project.
          </p>
        </div>

        <div className="space-y-16">
          {mockData.founders.map((founder) => (
            <div
              key={founder.id}
              className="group bg-gradient-to-br from-orange-50 to-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              <div className="grid md:grid-cols-2 gap-0">
                <div className="relative aspect-square md:aspect-auto overflow-hidden">
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-8 md:p-12 flex flex-col justify-center">
                  {founder.headline && (
                    <p className="text-orange-600 font-semibold text-sm uppercase tracking-wider mb-4">
                      {founder.headline}
                    </p>
                  )}
                  <h3 className="text-3xl font-bold text-gray-900 mb-2">
                    {founder.name}
                  </h3>
                  <p className="text-orange-600 font-semibold mb-6 uppercase tracking-wide text-lg">
                    {founder.role}
                  </p>
                  
                  {founder.quote && (
                    <div className="bg-orange-100 p-6 rounded-xl mb-6 relative">
                      <Quote className="text-orange-600 opacity-30 absolute top-4 left-4" size={32} />
                      <p className="text-gray-800 italic text-lg pl-8 relative z-10">
                        {founder.quote}
                      </p>
                    </div>
                  )}
                  
                  <div className="text-gray-700 leading-relaxed space-y-4">
                    {founder.bio.split('\n\n').map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
